const pluck = (propName) => (o) => o[propName];

export default pluck;
